module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.147a0e88.jpg";